import { tripClient } from "@/api/grpc";
import { useAuthedRpc } from "@/hooks/common";
import { create } from "@bufbuild/protobuf";
import {
  TripSchema,
  UserPathSchema,
} from "@generated/proto/model";
import { CreateTripRequestSchema } from "@generated/proto/service";

/**
 * Hook for TripService.CreateTrip
 */
export function useCreateTrip() {
  const { run, loading, error } = useAuthedRpc(
    async (
      user,
      title: string,
      description: string,
      dates?: {
        departure?: { year: number; month: number; day: number }
        return?: { year: number; month: number; day: number }
      }
    ) => {
      if (!title?.trim() || !description?.trim()) {
        throw new Error("Title and description are required.");
      }

      const request = create(CreateTripRequestSchema, {
        trip: create(TripSchema, {
          title,
          description,
          departureDate: dates?.departure,
          returnDate: dates?.return,
        }),
        userPath: create(UserPathSchema, { userId: user.uid }),
      });

      const response = await tripClient.createTrip(request as any);
      return response;
    }
  );

  return { createTrip: run, loading, error };
}


